export default {"src":"/_next/static/media/call-blue.42647ce2.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};